import React, { useState, useRef, useEffect } from 'react';
import { 
    FormControl, FormLabel, Input, Button, ButtonGroup, Text, Icon, Select, HStack, Image,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, useToast
} from '@chakra-ui/react';
import { MdSave, MdClose } from 'react-icons/md';
import axios from 'axios';
import {faker} from '@faker-js/faker';
import { Form, Field } from 'react-final-form';
import validator from "validator";
import moment from 'moment';
import { REACT_APP_UPLOADS_ENDPOINT_URL, ERROR_CODES, PRICING_LIST } from '../../../constants';

// import DropZonePreview from '../../../components/DropZone';
import DropZoneWithImage from '../../../components/DropZoneWithImage';

function AddEditCompanyModal({ 
    companyList, companyDetail, actionStatus, initialRef, isOpen, onClose, 
    apiCreateNewCompany, apiUpdateACompany,  
}) {
    const [ logoFile, setLogoFile ] = useState(null);
    const [ isValidPhone, setIsValidPhone ] = useState(true);
    const [ isValidEmail, setIsValidEmail ] = useState(true);
    const [ isProcessing, setIsProcessing ] = useState(false);
    const toast = useToast();

    useEffect(() => {
        if(!actionStatus) {
            setIsProcessing(false);
        }
    }, [actionStatus]);

    const validate = (values) => {
        const errors = {};

        if(!values.name) {
            errors.name = "Required";
        }
        if(!values.owner) {
            errors.owner = "Required";
        }
        if(!values.address) {
            errors.address = "Required";
        }
        if(!values.email) {
            errors.email = "Required";
        }
        if(!values.phone) {
            errors.phone = "Required";
        }
        if(!values.logo_url) {
            if(!logoFile) {
                errors.logoFile = "Required";
            }
        }
        if(!values.register_type) {
            errors.register_type = "Required";
        }

        if(values.phone?.length > 0) {
            const isValidPhone = validator.isMobilePhone(values.phone, "vi-VN");
            setIsValidPhone(isValidPhone);
            if(!isValidPhone) {
                errors.validPhone = "Required";
            }
        }

        if(values.email?.length > 0) {
            const isValidEmail = validator.isEmail(values.email);
            setIsValidEmail(isValidEmail);
            if(!isValidEmail) {
                errors.validEmail = "Required";
            }
        }

        console.log("--- values", values)
        console.log("--- errors", errors)
        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);
        let logo_url = null;
        
        try
        {
            if(logoFile) {
                // upload logo
                let logoFiledata = new FormData();
                logoFiledata.append('uri', logoFile);

                let resUpload = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/upload?subPath=companies`, logoFiledata, { 
                    headers: { "Content-Type": "multipart/form-data" },
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                });

                if(resUpload.data?.status === 200) {
                    logo_url = resUpload.data.fileName;
                }
            }

            // tính toán thời hạn sử dụng phần mềm
            const TOTAL_MONTH_ACTIVED = PRICING_LIST[values.register_type]?.total_month_actived; 
            const MAX_USER_REGISTER = PRICING_LIST[values.register_type]?.max_user_register;
            const REGISTER_CODE = faker.string.alphanumeric(8).toUpperCase();

            if(companyDetail && companyDetail.id) {
                apiUpdateACompany({ 
                    id: companyDetail.id, 
                    payload: {
                        ...values,
                        is_active: true, 
                        logo_url: logo_url || companyDetail?.logo_url,
                        register_type: values.register_type,
                        active_expired: moment(new Date() >= companyDetail?.active_expired ? new Date() : companyDetail?.active_expired).add(TOTAL_MONTH_ACTIVED, "month").toDate(),
                    } 
                });
            } else {
                apiCreateNewCompany({ 
                    ...values,
                    is_active: true, 
                    logo_url,
                    register_type: values.register_type,
                    register_code: REGISTER_CODE,
                    register_code_expired: moment(new Date()).add("60", "minutes").toDate(),
                    active_expired: moment(new Date()).add(TOTAL_MONTH_ACTIVED, "month").toDate(),
                    max_user_register: MAX_USER_REGISTER
                });
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="lg">
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    ...companyDetail
                }}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <ModalContent>
                                <ModalHeader>
                                    { companyDetail && companyDetail.id ? "CẬP NHẬT" : "TẠO MỚI" }
                                </ModalHeader>
                                <ModalCloseButton />

                                <ModalBody pb={6}>
                                    <Field name="name">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Tên phòng khám (tối đa 25 chữ)</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập tên' maxLength={25}/>
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="owner">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Người Đại Diện</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập người đại diện' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="address">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Địa chỉ</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập địa chỉ' />
                                            </FormControl>
                                        )}
                                    </Field>
                                    
                                    <Field name="phone">
                                        {({ input, meta }) => (
                                            <FormControl mt={4} isRequired>
                                                <FormLabel>Số Điện Thoại</FormLabel>
                                                <Input {...input} type="tel" placeholder='Nhập số điện thoại' />
                                                {
                                                    !isValidPhone &&
                                                    <FormLabel color="red">Nhập đúng Số Điện Thoại</FormLabel>
                                                }
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="email">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Email</FormLabel>
                                                <Input {...input} type="email" placeholder='Nhập email' />
                                                {
                                                    !isValidEmail &&
                                                    <FormLabel color="red">Nhập đúng Email</FormLabel>
                                                }
                                            </FormControl>
                                        )}
                                    </Field>

                                    <FormControl mt={4} isRequired>
                                        <FormLabel>Logo</FormLabel>
                                        <HStack spacing={2}>
                                            {
                                                companyDetail?.logo_url && !logoFile &&
                                                <Image alt="logo" src={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/companies/${companyDetail?.logo_url}`} 
                                                    width="100px" height="100px"
                                                />
                                            }
                                            <DropZoneWithImage callback={setLogoFile}/>
                                        </HStack>
                                    </FormControl>

                                    <Field name="register_type">
                                        {({ input, meta }) => (
                                            <FormControl mt={4} isRequired>
                                                <FormLabel>Chọn gói dịch vụ phần mềm</FormLabel>
                                                <Select {...input} placeholder='Chọn gói dịch vụ phần mềm'>
                                                    {
                                                        Object.keys(PRICING_LIST).map(key => (
                                                            <React.Fragment key={key}>
                                                                <option value={key}>{PRICING_LIST[key]?.label}</option>
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="alarm_phone">
                                        {({ input, meta }) => (
                                            <FormControl>
                                                <FormLabel>Số điện thoại cấp cứu</FormLabel>
                                                <Input {...input} type="tel" placeholder='Nhập số điện thoại cấp cứu' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="work_time">
                                        {({ input, meta }) => (
                                            <FormControl>
                                                <FormLabel>Giờ làm việc (Ví dụ: 07:00 - 17:00)</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập giờ làm việc' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="parent_company_id">
                                        {({ input, meta }) => (
                                            <FormControl mt={4}>
                                                <FormLabel>Chi nhánh của Phòng Khám</FormLabel>
                                                <Select {...input} placeholder='Chọn phòng khám'>
                                                    {
                                                        companyList.map(item => (
                                                            <React.Fragment key={item.id}>
                                                                <option value={item.id}>{item.name}</option>
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        )}
                                    </Field>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid}
                                        isLoading={isProcessing}
                                        loadingText="Đang lưu"
                                    >
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">Lưu</Text>
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </form>
                    )
                }}
            />
        </Modal>
    )
}

export default AddEditCompanyModal;